import { render, staticRenderFns } from "./staff.vue?vue&type=template&id=b7d7a02c&scoped=true&"
import script from "./staff.vue?vue&type=script&lang=js&"
export * from "./staff.vue?vue&type=script&lang=js&"
import style0 from "./staff.vue?vue&type=style&index=0&id=b7d7a02c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7d7a02c",
  null
  
)

export default component.exports